import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import CardTransparent from 'components/desktop/_general/Card/CardTransparent';
import MultiSearchSelect from 'components/desktop/_general/MultiSearchSelect/MultiSearchSelect';
import { AllergenLogic } from 'enums/allergenLogic';
import { ISelectItem } from 'interfaces/ISelectItem';
import * as AllergenList from 'types/_general/Store/AllergenList';

export type PreferredAllergen = {
	id: string;
	logic: AllergenLogic;
};
export type ISelectItemAllergen = ISelectItem & { logic: AllergenLogic };

interface IProps {
	allergensAll: AllergenList.Type;
	preferredAllergens: PreferredAllergen[];
	handleEditAllergens: (input: ISelectItemAllergen[]) => void;
}

const ChangeAllergens = (props: IProps) => {
	const { t } = useTranslation();
	const [suggestedAllergen, setSuggestedAllergen] = useState<ISelectItemAllergen[]>([]);

	const allergenNames = useMemo(
		() =>
			props.allergensAll.toDictionary(
				(k) => k.id + '_' + k.logic,
				(v) => v.name
			),
		[props.allergensAll]
	);

	const mapToISelectItem = (input: PreferredAllergen[]): ISelectItemAllergen[] => {
		return input.map((allergen) => {
			return {
				id: allergen.id,
				logic: allergen.logic,
				name: allergenNames[allergen.id + '_' + allergen.logic],
				title:
					allergen.logic === AllergenLogic.MayContain
						? 'Allergen'
						: allergen.logic === AllergenLogic.Negative
						? 'Negativ'
						: 'Positiv',
			};
		});
	};

	const getAllergenStartingWith = async (searchTerm: string): Promise<void> => {
		const filteredAllergen = props.allergensAll.filter(
			(e) => e.name && e.name.toLowerCase().startsWith(searchTerm.toLowerCase())
		);

		setSuggestedAllergen(filteredAllergen);
	};

	return (
		<CardTransparent
			title={t('_general:ADVANCED_FILTER')}
			content={
				<>
					<MultiSearchSelect
						savedItems={mapToISelectItem(props.preferredAllergens)}
						backgroundColor={'#efefef'}
						setSavedItems={props.handleEditAllergens as any}
						displaySavedItems="bottom"
						suggestedItems={suggestedAllergen}
						handleChangeSearchTerm={getAllergenStartingWith}
						label={t('user:ALLERGEN_CONFIGURATION')}
						triggerSearchLetterAmount={0}
					/>
				</>
			}
		/>
	);
};

export default ChangeAllergens;
